import { render, staticRenderFns } from "./ServiceRequestDetail.vue?vue&type=template&id=1fdd7409&scoped=true&"
import script from "./ServiceRequestDetail.vue?vue&type=script&lang=js&"
export * from "./ServiceRequestDetail.vue?vue&type=script&lang=js&"
import style0 from "./ServiceRequestDetail.vue?vue&type=style&index=0&id=1fdd7409&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fdd7409",
  null
  
)

export default component.exports